module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7ff87acd3118d86a8397ef9763da4f70.png";